import { mutationOptions } from '@tanstack/react-query'
import type { QueryError } from 'src/queries/network.utils'
import type { PostTransactionMessageResponse } from 'src/queries/transactionConversations/transactionConversations.models'
import {
  postTransactionMessage,
  type PostTransactionMessageParams,
} from 'src/queries/transactionConversations/transactionConversations.network'

export const transactionConversationMutations = {
  postMessage: () =>
    mutationOptions<
      PostTransactionMessageResponse,
      QueryError,
      PostTransactionMessageParams
    >({
      mutationFn: postTransactionMessage,
    }),
}
